module.exports = "<div>\n  <div ng-repeat=\"priloha in prilohy\">\n    <priloha ng-model=\"prilohy[$index]\"></priloha>\n  </div>\n  <button type=\"button\" class=\"btn btn-default\" ng-click=\"selectFile()\" ng-if=\"!readonly\">\n    Pridať prílohu\n  </button>\n  <span ng-if=\"!readonly\">\n    Prílohu môžete pridať pretiahnutím súboru pomocou drag&amp;drop.\n  </span>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/util/prilohy.html
// module id = 303
// module chunks = 0